module.exports = __webpack_public_path__ + "static/media/MobileAirCompresser.1470c2e4.png";